import React from 'react'
import Button from '@Components/Buttons/Button'
import Navigation from '@App/navigation'
import './index.scss'

const NoSongwritersMessage = () => (
    <div className="no-songwriters-message">
        <p>
            <strong>You have nothing here</strong>
        </p>
        <p>
            The MLC Songwriter Hub is a central place for songwriters to verify information in an effort to locate all
            songs they may have claims on and manage their catalog.
        </p>
        <Button mainColor typeLink type="primary" linkTo={Navigation.registrationSongwriter.root()}>
            Join Songwriter Hub
        </Button>
    </div>
)

export default NoSongwritersMessage
